import { React, useEffect } from 'react'
import TopBanner from '../../../components/topBanner/topBanner';
import imgBaner from "../../../images/banner/banner---gioi-thieu.png";
import TitleCenter from '../../../components/title/TitleCenter';
import PScategory from './PScategory';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '../../../utils/localeDataLoader';

function ProductSolution() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const languageCode = normalizeLang(i18n.language);
    const expectedBasePath = languageCode === 'vi' ? '/san-pham-giai-phap' : '/products-solutions';
    const currentPath = location.pathname;
    
    // Check if we are exactly at the base path (with or without trailing slash)
    if (currentPath === '/san-pham-giai-phap' || currentPath === '/san-pham-giai-phap/' || 
        currentPath === '/products-solutions' || currentPath === '/products-solutions/') {
      if (!currentPath.startsWith(expectedBasePath)) {
        navigate(expectedBasePath, { replace: true });
      }
    }
  }, [i18n.language, location.pathname, navigate]);
  return (
    <div className='ProductSolution'>
      <TopBanner
        titleCenter="Sản Phẩm và Giải Pháp"
        imgBanner={imgBaner}
        pageName="Sản Phẩm và Giải Pháp"
      />
      <div className='layout_container'>

        <TitleCenter
          text="Sản Phẩm và Giải Pháp"
        />
        <h4 style={{ fontSize: "2rem", textAlign: "center" }}>Chúng tôi cung cấp các giải pháp công nghệ với chất lượng tối ưu nhằm <br />
          thỏa mãn tối đa nhu cầu của khách hàng</h4>
        <PScategory />
      </div>
    </div>
  )
}

export default ProductSolution